var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.214 4.90179L6.21403 11.9018C6.15306 11.963 6.08062 12.0115 6.00085 12.0446C5.92108 12.0778 5.83556 12.0948 5.74919 12.0948C5.66281 12.0948 5.57729 12.0778 5.49752 12.0446C5.41775 12.0115 5.34531 11.963 5.28434 11.9018L2.22184 8.83929C2.1608 8.77825 2.11237 8.70578 2.07934 8.62602C2.0463 8.54626 2.0293 8.46078 2.0293 8.37445C2.0293 8.28812 2.0463 8.20264 2.07934 8.12288C2.11237 8.04312 2.1608 7.97065 2.22184 7.90961C2.28289 7.84856 2.35536 7.80014 2.43511 7.7671C2.51487 7.73407 2.60036 7.71706 2.68669 7.71706C2.77301 7.71706 2.8585 7.73407 2.93826 7.7671C3.01801 7.80014 3.09048 7.84856 3.15153 7.90961L5.74973 10.5078L12.2854 3.9732C12.4087 3.84992 12.5759 3.78065 12.7503 3.78065C12.9246 3.78065 13.0918 3.84992 13.2151 3.9732C13.3384 4.09648 13.4077 4.26369 13.4077 4.43804C13.4077 4.61239 13.3384 4.7796 13.2151 4.90289L13.214 4.90179Z",
    fill: "#FAFDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.c6f87030ee8c5ec4d3a5a91258b16e1b.svg";
export { ForwardRef as ReactComponent };